import React, { useEffect, useState } from "react";
import "../../../../views/stylesheet/styles.css";
import Divider from "@mui/material/Divider";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import Stack from "@material-ui/core/Stack";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import ApiCall from "../../../../ApiService/ApiGateway/apiGateway";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Input } from "@material-ui/core";
import { isInvalidEmail } from "../../../../utils/utils";
toast.configure({
  position: toast.POSITION.BOTTOM_LEFT,
  autoClose: 3000,
});

function Settings({ close }) {
  const [emailList, setEmailList] = useState([]);
  const [email, setEmail] = useState("");
  useEffect(() => {
    ApiCall.get(`admin`, (response) => {
      console.log(response);
      if (response.success) {
        let emailAddressList =
          response?.data?.admin?.send_notification_email ?? [];
        setEmailList(emailAddressList);
      }
    });
  }, []);
  const handleEmailListPush = (e) => {
    var emailRegex =
      /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    let value = e.target.value;

    if (e.key === "Enter") {
      if (!emailRegex.test(value)) {
        toast.error("Please enter a valid email address");
      } else {
        emailList.push(value);
        setEmailList(emailList);
        setEmail("");
      }
    }
  };
  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };
  const closeModal = () => {
    setEmail("");
    setEmailList([]);
    close();
  };
  const handleSubmitEmailList = () => {
    if (emailList.length === 0 && !email) {
      toast.error("Please enter valid email address");
    } else if (emailList.length === 0) {
      toast.error("Please press key enter to add email address");
    } else {
      let data = {
        send_notification_email: emailList,
      };
      // console.log(data);
      ApiCall.patch(`admin`, data, (response) => {
        if (response.success) {
          closeModal();
          // console.log(response);
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      });
    }
  };
  const handleChipClick = () => {};
  const handleChipDelete = (value, index) => {
    if (emailList[index] === value) {
      emailList.splice(index, 1);
      setEmailList([...emailList]);
    }
  };
  return (
    <div className="drawerWidth-emailList">
      <div className="title2">Update Email</div>
      <Divider />
      <div className="content">
        <div className="mb-24">
          <div className="fieldName mb-24">
            Email* <span className="info">(Type email id and press enter)</span>
          </div>
          <div className="passwordField multiInputField">
            <Stack gap={2} direction="row" flexWrap="wrap">
              {emailList.length > 0 &&
                emailList.map((el, i) => (
                  <Chip
                    label={el}
                    onClick={handleChipClick}
                    onDelete={() => handleChipDelete(el, i)}
                  />
                ))}
              <div className="multi-email-input">
                <input
                  onChange={(e) => handleInputChange(e)}
                  onKeyDown={(e) => handleEmailListPush(e)}
                  className=""
                  value={email}
                  name="email"
                  placeholder=""
                ></input>
              </div>
            </Stack>
          </div>
        </div>

        <div className="buttons">
          <div
            className="cancel"
            onClick={() => {
              close();
            }}
          >
            Cancel
          </div>
          <Button variant="contained" onClick={() => handleSubmitEmailList()}>
            Save
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Settings;
